export default __webpack_public_path__ + "static/media/019-macaroon.698ef745.svg";